export let genres = {
    "Contemporary romances": [
       {
          "ISBN": 9780553391961,
          "Author": "Macomber, Debbie",
          "Title": "If not for you"
       },
       {
          "ISBN": 9780778319917,
          "Author": "Carr, Robyn",
          "Title": "Any day now"
       },
       {
          "ISBN": 9780373802760,
          "Author": "Mallery, Susan",
          "Title": "Secrets of the tulip sisters"
       },
       {
          "ISBN": 9780373803927,
          "Author": "Miller, Linda Lael",
          "Title": "Forever a hero"
       },
       {
          "ISBN": 9780778331339,
          "Author": "Woods, Sherryl",
          "Title": "Lilac Lane"
       },
       {
          "ISBN": 9780451488022,
          "Author": "Anderson, Catherine (Adeline Catherine)",
          "Title": "Mulberry moon"
       },
       {
          "ISBN": 9781496709578,
          "Author": "Dailey, Janet",
          "Title": "Texas fierce"
       },
       {
          "ISBN": 9780373789672,
          "Author": "Foster, Lori, 1958-",
          "Title": "Worth the wait"
       },
       {
          "ISBN": 9780778330585,
          "Author": "Neggers, Carla",
          "Title": "Red Clover Inn"
       },
       {
          "ISBN": 9780373804214,
          "Author": "Palmer, Diana",
          "Title": "Wyoming winter"
       },
       {
          "ISBN": 9780062660138,
          "Author": "Shalvis, Jill",
          "Title": "Accidentally on purpose"
       },
       {
          "ISBN": 9781496707321,
          "Author": "Alers, Rochelle",
          "Title": "Breakfast in bed"
       },
       {
          "ISBN": 9780399586347,
          "Author": "Anderson, Catherine (Adeline Catherine)",
          "Title": "Spring forward"
       },
       {
          "ISBN": 9780399585074,
          "Author": "Burton, Jaci",
          "Title": "Love me again"
       },
       {
          "ISBN": 9781492616344,
          "Author": "Chase, Samantha",
          "Title": "A sky full of stars"
       },
       {
          "ISBN": 9780373804207,
          "Author": "Daniels, B. J.",
          "Title": "Cowboy's legacy"
       },
       {
          "ISBN": 9781496705761,
          "Author": "Dev, Sonali",
          "Title": "A distant heart"
       },
       {
          "ISBN": 9780451488510,
          "Author": "Feehan, Christine",
          "Title": "Judgment road"
       },
       {
          "ISBN": 9780062247476,
          "Author": "Gibson, Rachel",
          "Title": "The art of running in heels"
       },
       {
          "ISBN": 9781501151224,
          "Author": "Harper, Molly",
          "Title": "Sweet tea and sympathy"
       },
       {
          "ISBN": 9780373838844,
          "Author": "Jackson, Brenda (Brenda Streater)",
          "Title": "His secret son"
       },
       {
          "ISBN": 9780425273777,
          "Author": "James, Julie, 1974-",
          "Title": "The thing about love"
       },
       {
          "ISBN": 9780399584718,
          "Author": "McKinlay, Jenn",
          "Title": "About a dog"
       },
       {
          "ISBN": 9780778331087,
          "Author": "Novak, Brenda",
          "Title": "Right where we belong"
       },
       {
          "ISBN": 9781501124297,
          "Author": "Probst, Jennifer",
          "Title": "All or nothing at all"
       }
    ],
    "Science fiction": [
       {
          "ISBN": 9780553448122,
          "Author": "Weir, Andy",
          "Title": "Artemis"
       },
       {
          "ISBN": 9780316547611,
          "Author": "Alderman, Naomi",
          "Title": "The power"
       },
       {
          "ISBN": 9781501163401,
          "Author": "King, Stephen, 1947-",
          "Title": "Sleeping beauties"
       },
       {
          "ISBN": 9780316346962,
          "Author": "Patterson, James, 1947-",
          "Title": "Humans, bow down"
       },
       {
          "ISBN": 9781534300606,
          "Author": "Vaughan, Brian K.",
          "Title": "Saga. Volume 7"
       },
       {
          "ISBN": 9780765337917,
          "Author": "Graham, Heather",
          "Title": "The rising"
       },
       {
          "ISBN": 9780765393135,
          "Author": "Okorafor, Nnedi",
          "Title": "Binti: the night masquerade"
       },
       {
          "ISBN": 9780765377043,
          "Author": "Card, Orson Scott",
          "Title": "Children of the fleet"
       },
       {
          "ISBN": 9780316332835,
          "Author": "Corey, James S. A.",
          "Title": "Persepolis rising"
       },
       {
          "ISBN": 9780316262347,
          "Author": "Robinson, Kim Stanley",
          "Title": "New York 2140"
       },
       {
          "ISBN": 9780385541787,
          "Author": "Wilson, Daniel H. (Daniel Howard), 1'978-",
          "Title": "The clockwork dynasty"
       },
       {
          "ISBN": 9780316229241,
          "Author": "Jemisin, N. K.",
          "Title": "The stone sky"
       },
       {
          "ISBN": 9780374115241,
          "Author": "VanderMeer, Jeff",
          "Title": "Borne"
       },
       {
          "ISBN": 9781410496768,
          "Author": "Mastai, Elan",
          "Title": "All our wrong todays"
       },
       {
          "ISBN": 9780062383273,
          "Author": "Yuknavitch, Lidia",
          "Title": "The book of Joan"
       },
       {
          "ISBN": 9780765388889,
          "Author": "Scalzi, John, 1969-",
          "Title": "The collapsing empire"
       },
       {
          "ISBN": 9781616205225,
          "Author": "Williams, David",
          "Title": "When the English fall"
       },
       {
          "ISBN": 9780765392763,
          "Author": "Doctorow, Cory",
          "Title": "Walkaway"
       },
       {
          "ISBN": 9780425285916,
          "Author": "Brown, Pierce, 1988-",
          "Title": "Iron gold"
       },
       {
          "ISBN": 9780765392077,
          "Author": "Newitz, Annalee",
          "Title": "Autonomous"
       },
       {
          "ISBN": 9780765376732,
          "Author": "Forstchen, William R.",
          "Title": "The final day"
       },
       {
          "ISBN": 9780735214316,
          "Author": "Jones, Holly Goddard",
          "Title": "The salt line"
       },
       {
          "ISBN": 9780316555562,
          "Author": "Reynolds, Alastair, 1966-",
          "Title": "Revenger"
       },
       {
          "ISBN": 9781101886724,
          "Author": "Neuvel, Sylvain, 1973-",
          "Title": "Waking gods"
       }
    ],
    "Fantasy fiction": [
       {
          "ISBN": 9781250122957,
          "Author": "Roberts, Nora",
          "Title": "Year one"
       },
       {
          "ISBN": 9780062409164,
          "Author": "Stephenson, Neal",
          "Title": "The rise and fall of D.O.D.O"
       },
       {
          "ISBN": 9780765387462,
          "Author": "Schwab, Victoria",
          "Title": "A conjuring of light"
       },
       {
          "ISBN": 9781101885963,
          "Author": "Arden, Katherine",
          "Title": "The girl in the tower"
       },
       {
          "ISBN": 9781632866240,
          "Author": "Shannon, Samantha, 1991-",
          "Title": "The song rising"
       },
       {
          "ISBN": 9780451474490,
          "Author": "Bishop, Anne",
          "Title": "Etched in bone: a novel of the others"
       },
       {
          "ISBN": 9780812995947,
          "Author": "LaValle, Victor D., 1972-",
          "Title": "The changeling"
       },
       {
          "ISBN": 9780062668165,
          "Author": "Snipes, Wesley",
          "Title": "Talon of God"
       },
       {
          "ISBN": 9780399178481,
          "Author": "Poore, Michael",
          "Title": "Reincarnation blues"
       },
       {
          "ISBN": 9780399586132,
          "Author": "Donaldson, Stephen R.",
          "Title": "Seventh decimate"
       },
       {
          "ISBN": 9780765392039,
          "Author": "McGuire, Seanan",
          "Title": "Down among the sticks and bones"
       },
       {
          "ISBN": 9780399583179,
          "Author": "Stirling, S. M.",
          "Title": "The sea peoples: a novel of the Change"
       },
       {
          "ISBN": 9780765380135,
          "Author": "Bear, Elizabeth",
          "Title": "The stone in the skull"
       },
       {
          "ISBN": 9781250083524,
          "Author": "Abraham, Brad",
          "Title": "Magicians impossible"
       },
       {
          "ISBN": 9781101988688,
          "Author": "Cogman, Genevieve",
          "Title": "The burning page"
       },
       {
          "ISBN": 9780451488244,
          "Author": "Singh, Nalini, 1977-",
          "Title": "Archangel's viper"
       },
       {
          "ISBN": 9781619845534,
          "Author": "Kova, Elise",
          "Title": "The dragons of Nova"
       },
       {
          "ISBN": 9780765393586,
          "Author": "McGuire, Seanan",
          "Title": "Beneath the sugar sky"
       },
       {
          "ISBN": 9780425284025,
          "Author": "Bates, Callie",
          "Title": "The waking land"
       },
       {
          "ISBN": 9781504038782,
          "Author": "Anthony, Piers",
          "Title": "Ghost writer in the sky"
       },
       {
          "ISBN": 9781250073037,
          "Author": "Kristoff, Jay",
          "Title": "Godsgrave"
       },
       {
          "ISBN": 9781596068445,
          "Author": "Bujold, Lois McMaster",
          "Title": "Penric's mission"
       },
       {
          "ISBN": 9780765392534,
          "Author": "Rivera, K. Arsenault",
          "Title": "The tiger's daughter"
       },
       {
          "ISBN": 9781501161056,
          "Author": "Pielmeier, John",
          "Title": "Hook's tale: being the account of an unjustly villainized pirate written by himself"
       }
    ],
    "Mysteries": [
       {
          "ISBN": 9781501171642,
          "Author": "Clark, Mary Higgins",
          "Title": "Every breath you take"
       },
       {
          "ISBN": 9780399179198,
          "Author": "Evanovich, Janet",
          "Title": "Hardcore Twenty-four"
       },
       {
          "ISBN": 9780316225908,
          "Author": "Connelly, Michael, 1956-",
          "Title": "Two kinds of truth"
       },
       {
          "ISBN": 9781250066190,
          "Author": "Penny, Louise",
          "Title": "Glass houses"
       },
       {
          "ISBN": 9780399163852,
          "Author": "Grafton, Sue",
          "Title": "Y is for yesterday"
       },
       {
          "ISBN": 9780316274036,
          "Author": "Patterson, James, 1947-",
          "Title": "16th seduction"
       },
       {
          "ISBN": 9780345541437,
          "Author": "Kellerman, Jonathan",
          "Title": "Heartbreak Hotel"
       },
       {
          "ISBN": 9780399161506,
          "Author": "Crais, Robert",
          "Title": "The wanted"
       },
       {
          "ISBN": 9780451494320,
          "Author": "Lagercrantz, David",
          "Title": "The girl who takes an eye for an eye"
       },
       {
          "ISBN": 9780062657541,
          "Author": "Jance, Judith A.",
          "Title": "Proof of life"
       },
       {
          "ISBN": 9780062645227,
          "Author": "Horowitz, Anthony, 1955-",
          "Title": "Magpie murders"
       },
       {
          "ISBN": 9781455536375,
          "Author": "Deaver, Jeffery",
          "Title": "The burial hour"
       },
       {
          "ISBN": 9780062424969,
          "Author": "Kellerman, Faye",
          "Title": "Bone box"
       },
       {
          "ISBN": 9780062435842,
          "Author": "Paretsky, Sara",
          "Title": "Fallout"
       },
       {
          "ISBN": 9781101871379,
          "Author": "McCall Smith, Alexander, 1948-",
          "Title": "The house of unexpected sisters"
       },
       {
          "ISBN": 9780385538916,
          "Author": "Bohjalian, Chris, 1960-",
          "Title": "The sleepwalker"
       },
       {
          "ISBN": 9780385352161,
          "Author": "Nesbo, Jo, 1960-",
          "Title": "The thirst"
       },
       {
          "ISBN": 9780399177002,
          "Author": "Atkins, Ace",
          "Title": "Robert B. Parker's Little white lies"
       },
       {
          "ISBN": 9780425284988,
          "Author": "Perry, Anne",
          "Title": "Murder on the Serpentine: a Charlotte and Thomas Pitt novel"
       },
       {
          "ISBN": 9780062436603,
          "Author": "Winspear, Jacqueline, 1955-",
          "Title": "In this grave hour"
       },
       {
          "ISBN": 9781617732201,
          "Author": "Fluke, Joanne, 1943-",
          "Title": "Banana cream pie murder"
       },
       {
          "ISBN": 9781250105608,
          "Author": "Harper, Jane (Jane Elizabeth)",
          "Title": "The dry"
       },
       {
          "ISBN": 9781250090065,
          "Author": "Harris, Charlaine",
          "Title": "Sleep like a baby"
       },
       {
          "ISBN": 9781250057464,
          "Author": "Beaton, M. C.",
          "Title": "The witches' tree"
       }
    ],
    "History writing": [
       {
          "ISBN": 9781594204876,
          "Author": "Chernow, Ron",
          "Title": "Grant"
       },
       {
          "ISBN": 9781501139154,
          "Author": "Isaacson, Walter",
          "Title": "Leonardo da Vinci"
       },
       {
          "ISBN": 9780385534246,
          "Author": "Grann, David",
          "Title": "Killers of the Flower Moon: the Osage murders and the birth of the FBI"
       },
       {
          "ISBN": 9780804190114,
          "Author": "Snyder, Timothy",
          "Title": "On tyranny: twenty lessons from the twentieth century"
       },
       {
          "ISBN": 9780062569035,
          "Author": "Baier, Bret",
          "Title": "Three days in January: Dwight Eisenhower's final mission"
       },
       {
          "ISBN": 9781627790642,
          "Author": "O'Reilly, Bill",
          "Title": "Killing England: the brutal struggle for American independence"
       },
       {
          "ISBN": 9781631492853,
          "Author": "Rothstein, Richard",
          "Title": "The color of law: a forgotten history of how our government segregated America"
       },
       {
          "ISBN": 9780802127006,
          "Author": "Bowden, Mark, 1951-",
          "Title": "Hue 1968: the turning point of the American war in Vietnam"
       },
       {
          "ISBN": 9780735213234,
          "Author": "Kilmeade, Brian",
          "Title": "Andrew Jackson and the miracle of New Orleans: the battle that shaped America's destiny"
       },
       {
          "ISBN": 9781492649359,
          "Author": "Moore, Kate, (Writer and editor)",
          "Title": "The radium girls: the dark story of America's shining women"
       },
       {
          "ISBN": 9781594206139,
          "Author": "Ricks, Thomas E.",
          "Title": "Churchill and Orwell: the fight for freedom"
       },
       {
          "ISBN": 9780735224711,
          "Author": "Wood, Gordon S.",
          "Title": "Friends divided: John Adams and Thomas Jefferson"
       },
       {
          "ISBN": 9780307700254,
          "Author": "Ward, Geoffrey C.",
          "Title": "The Vietnam War: an intimate history"
       },
       {
          "ISBN": 9781476794044,
          "Author": "Kiernan, Denise",
          "Title": "The last castle: the epic story of love, loss, and American royalty in the nation's largest home"
       },
       {
          "ISBN": 9780062430489,
          "Author": "Fagone, Jason",
          "Title": "The woman who smashed codes: a true story of love, spies, and the unlikely heroine who outwitted America's enemies"
       },
       {
          "ISBN": 9781594203800,
          "Author": "Kotkin, Stephen",
          "Title": "Stalin: waiting for Hitler 1929-1941"
       },
       {
          "ISBN": 9780399563140,
          "Author": "O'Donnell, Lawrence",
          "Title": "Playing with fire: the 1968 election and the transformation of American politics"
       },
       {
          "ISBN": 9780062666536,
          "Author": "Bacon, John U., 1964-",
          "Title": "The great Halifax explosion: a World War I story of treachery, tragedy, and extraordinary heroism"
       },
       {
          "ISBN": 9781250071484,
          "Author": "Clavin, Thomas",
          "Title": "Dodge City: Wyatt Earp, Bat Masterson, and the wickedest town in the American West"
       },
       {
          "ISBN": 9781476714844,
          "Author": "Tyson, Timothy B.",
          "Title": "The blood of Emmett Till"
       },
       {
          "ISBN": 9781627798327,
          "Author": "Kluger, Jeffrey",
          "Title": "Apollo 8: the thrilling story of the first mission to the Moon"
       },
       {
          "ISBN": 9781101980019,
          "Author": "Metaxas, Eric",
          "Title": "Martin Luther: the man who rediscovered God and changed the world"
       },
       {
          "ISBN": 9780062419095,
          "Author": "Henderson, Bruce B., 1946-",
          "Title": "Sons and soldiers: the untold story of the Jews who escaped the Nazis and returned with the U.S. Army to fight Hitler"
       },
       {
          "ISBN": 9781501126390,
          "Author": "Dunbar, Erica Armstrong",
          "Title": "Never caught: the Washingtons' relentless pursuit of their runaway slave, Ona Judge"
       }
    ],
    "Thrillers and Suspense": [
       {
          "ISBN": 9780316273909,
          "Author": "Patterson, James, 1947-",
          "Title": "The people vs. Alex Cross"
       },
       {
          "ISBN": 9781455586608,
          "Author": "Baldacci, David",
          "Title": "End game"
       },
       {
          "ISBN": 9780399593482,
          "Author": "Child, Lee",
          "Title": "The midnight line"
       },
       {
          "ISBN": 9780062354341,
          "Author": "Silva, Daniel, 1960-",
          "Title": "House of spies"
       },
       {
          "ISBN": 9780525955115,
          "Author": "Coben, Harlan, 1962-",
          "Title": "Don't let go"
       },
       {
          "ISBN": 9780385514231,
          "Author": "Brown, Dan, 1964-",
          "Title": "Origin"
       },
       {
          "ISBN": 9781455572106,
          "Author": "Brown, Sandra, 1948-",
          "Title": "Seeing red"
       },
       {
          "ISBN": 9780385543026,
          "Author": "Grisham, John",
          "Title": "Camino Island"
       },
       {
          "ISBN": 9780399184574,
          "Author": "Sandford, John, 1944 February 23-",
          "Title": "Golden prey"
       },
       {
          "ISBN": 9781250099563,
          "Author": "Scottoline, Lisa",
          "Title": "One perfect lie"
       },
       {
          "ISBN": 9780399573972,
          "Author": "Woods, Stuart",
          "Title": "Below the belt"
       },
       {
          "ISBN": 9781250075857,
          "Author": "Johansen, Iris",
          "Title": "Mind game"
       },
       {
          "ISBN": 9780525483427,
          "Author": "Koontz, Dean R. (Dean Ray), 1945-",
          "Title": "The whispering room"
       },
       {
          "ISBN": 9781501138065,
          "Author": "Coulter, Catherine",
          "Title": "Enigma"
       },
       {
          "ISBN": 9780345544070,
          "Author": "Reichs, Kathy",
          "Title": "Two nights"
       },
       {
          "ISBN": 9781476789385,
          "Author": "Thor, Brad",
          "Title": "Use of force"
       },
       {
          "ISBN": 9780062129383,
          "Author": "Lehane, Dennis",
          "Title": "Since we fell"
       },
       {
          "ISBN": 9780399184017,
          "Author": "Cussler, Clive",
          "Title": "Nighthawk: a novel from the NUMA Files"
       },
       {
          "ISBN": 9780062311153,
          "Author": "Iles, Greg",
          "Title": "Mississippi blood"
       },
       {
          "ISBN": 9780525954583,
          "Author": "Gardner, Lisa",
          "Title": "Right behind you"
       },
       {
          "ISBN": 9781101985397,
          "Author": "Hoag, Tami",
          "Title": "The boy"
       },
       {
          "ISBN": 9781617734663,
          "Author": "Jackson, Lisa",
          "Title": "You will pay"
       },
       {
          "ISBN": 9780399176159,
          "Author": "Berenson, Alex",
          "Title": "The prisoner"
       },
       {
          "ISBN": 9781101985557,
          "Author": "Gardiner, Meg",
          "Title": "Into the black nowhere"
       }
    ],
    "Psychological suspense": [
       {
          "ISBN": 9780735211209,
          "Author": "Hawkins, Paula",
          "Title": "Into the water"
       },
       {
          "ISBN": 9781501156007,
          "Author": "Ware, Ruth",
          "Title": "The lying game"
       },
       {
          "ISBN": 9780062688163,
          "Author": "Constantine, Liv",
          "Title": "The last Mrs. Parrish"
       },
       {
          "ISBN": 9780425285046,
          "Author": "Delaney, J. P.",
          "Title": "The girl before"
       },
       {
          "ISBN": 9781101990483,
          "Author": "Barton, Fiona",
          "Title": "The child"
       },
       {
          "ISBN": 9781250111173,
          "Author": "Pinborough, Sarah, 1972-",
          "Title": "Behind her eyes"
       },
       {
          "ISBN": 9780735221123,
          "Author": "Lapena, Shari, 1960-",
          "Title": "A stranger in the house"
       },
       {
          "ISBN": 9780062678416,
          "Author": "Finn, A. J.",
          "Title": "The woman in the window"
       },
       {
          "ISBN": 9780778319986,
          "Author": "Kubica, Mary",
          "Title": "Every last lie"
       },
       {
          "ISBN": 9780735220959,
          "Author": "Corry, Jane",
          "Title": "My husband's wife"
       },
       {
          "ISBN": 9781101985366,
          "Author": "Sager, Riley",
          "Title": "Final girls"
       },
       {
          "ISBN": 9781501101670,
          "Author": "Unger, Lisa, 1970-",
          "Title": "The red hunter"
       },
       {
          "ISBN": 9781476792439,
          "Author": "Andrews, V. C. (Virginia C.)",
          "Title": "Shattered memories"
       },
       {
          "ISBN": 9781250141439,
          "Author": "Walker, Wendy, 1967-",
          "Title": "Emma in the night"
       },
       {
          "ISBN": 9781250034564,
          "Author": "Stevens, Chevy",
          "Title": "Never let you go"
       },
       {
          "ISBN": 9781101988299,
          "Author": "Mackintosh, Clare",
          "Title": "I see you"
       },
       {
          "ISBN": 9780062390516,
          "Author": "Burke, Alafair",
          "Title": "The wife"
       },
       {
          "ISBN": 9781501170317,
          "Author": "Robotham, Michael, 1960-",
          "Title": "The secrets she keeps"
       },
       {
          "ISBN": 9780778313649,
          "Author": "Ellison, J. T.",
          "Title": "Lie to me"
       },
       {
          "ISBN": 9780735213005,
          "Author": "Dionne, Karen",
          "Title": "The Marsh King's daughter"
       },
       {
          "ISBN": 9780062427021,
          "Author": "Swanson, Peter, 1968-",
          "Title": "Her every fear"
       },
       {
          "ISBN": 9780385343299,
          "Author": "Richmond, Michelle, 1970-",
          "Title": "The marriage pact"
       },
       {
          "ISBN": 9780345476043,
          "Author": "Chaon, Dan",
          "Title": "Ill will"
       },
       {
          "ISBN": 9781250130921,
          "Author": "Hendricks, Greer",
          "Title": "The wife between us"
       }
    ],
    "Politics and global affairs": [
       {
          "ISBN": 9781501175565,
          "Author": "Clinton, Hillary Rodham",
          "Title": "What happened"
       },
       {
          "ISBN": 9780553447088,
          "Author": "Allen, Jonathan (Jonathan J. M.)",
          "Title": "Shattered: inside Hillary Clinton's doomed campaign"
       },
       {
          "ISBN": 9781455540181,
          "Author": "Rice, Condoleezza, 1954-",
          "Title": "Democracy: stories from the long road to freedom"
       },
       {
          "ISBN": 9781616207823,
          "Author": "Rather, Dan",
          "Title": "What unites us: reflections on patriotism"
       },
       {
          "ISBN": 9780525562511,
          "Author": "Harding, Luke, 1968-",
          "Title": "Collusion: secret meetings, dirty money, and how Russia helped Donald Trump win"
       },
       {
          "ISBN": 9781608468904,
          "Author": "Klein, Naomi, 1970-",
          "Title": "No is not enough: resisting Trump's shock politics and winning the world we need"
       },
       {
          "ISBN": 9781250120618,
          "Author": "Warren, Elizabeth",
          "Title": "This fight is our fight: the battle to save America's middle class"
       },
       {
          "ISBN": 9781472942241,
          "Author": "Murray, Douglas, 1979-",
          "Title": "The strange death of Europe: immigration, identity, Islam"
       },
       {
          "ISBN": 9780393254228,
          "Author": "Hayes, Christopher, 1979-",
          "Title": "A colony in a nation"
       },
       {
          "ISBN": 9781594634536,
          "Author": "Gessen, Masha",
          "Title": "The future is history: how totalitarianism reclaimed Russia"
       },
       {
          "ISBN": 9781849047999,
          "Author": "Goodhart, David",
          "Title": "The road to somewhere: the populist revolt and the future of politics"
       },
       {
          "ISBN": 9781101980965,
          "Author": "MacLean, Nancy",
          "Title": "Democracy in chains: the deep history of the radical Right's stealth Plan for America"
       },
       {
          "ISBN": 9781250138460,
          "Author": "Kasich, John",
          "Title": "Two paths: America divided or united"
       },
       {
          "ISBN": 9780812988840,
          "Author": "Taibbi, Matt",
          "Title": "I can't breathe: a killing on Bay Street"
       },
       {
          "ISBN": 9780062697431,
          "Author": "Lilla, Mark",
          "Title": "The once and future liberal: after identity politics"
       },
       {
          "ISBN": 9780312538088,
          "Author": "Lourie, Richard, 1940-",
          "Title": "Putin: his downfall and Russia's coming crash"
       },
       {
          "ISBN": 9781101906187,
          "Author": "Markham, Lauren",
          "Title": "The far away brothers: two young migrants and the making of an American life"
       },
       {
          "ISBN": 9781101871270,
          "Author": "Davis, Angela J.",
          "Title": "Policing the Black man: arrest, prosecution, and imprisonment"
       },
       {
          "ISBN": 9780393241174,
          "Author": "Soufan, Ali H.",
          "Title": "Anatomy of terror: from the death of Bin Laden to the rise of the Islamic State"
       },
       {
          "ISBN": 9780393241174,
          "Author": "Mishra, Pankaj",
          "Title": "Age of anger: a history of the present"
       },
       {
          "ISBN": 9781594206665,
          "Author": "Klimburg, Alexander, 1976-",
          "Title": "The darkening web: the war for cyberspace"
       },
       {
          "ISBN": 9781250146182,
          "Author": "Chomsky, Noam",
          "Title": "Global discontents: conversations on the rising threats to democracy"
       },
       {
          "ISBN": 9780300190885,
          "Author": "Abrams, Floyd",
          "Title": "The soul of the First Amendment"
       },
       {
          "ISBN": 9781608467730,
          "Author": "McCoy, Alfred W.",
          "Title": "In the shadows of the American century: the rise and decline of US global power"
       }
    ],
    "Mainstream fiction": [
       {
          "ISBN": 9781101946152,
          "Author": "Uncommon type: some stories",
          "Title": "Hanks, Tom, 1956-"
       },
       {
          "ISBN": 9780316435451,
          "Author": "Winter solstice",
          "Title": "Hilderbrand, Elin"
       },
       {
          "ISBN": 9781501101724,
          "Author": "The Cuban affair",
          "Title": "DeMille, Nelson"
       },
       {
          "ISBN": 9781501160769,
          "Author": "Beartown",
          "Title": "Backman, Fredrik, 1981-"
       },
       {
          "ISBN": 9780062473530,
          "Author": "The keeper of lost things",
          "Title": "Hogan, Ruth"
       },
       {
          "ISBN": 9781501111648,
          "Author": "The broken road",
          "Title": "Evans, Richard Paul"
       },
       {
          "ISBN": 9780812998269,
          "Author": "My not so perfect life",
          "Title": "Kinsella, Sophie"
       },
       {
          "ISBN": 9780307959577,
          "Author": "Saints for all occasions",
          "Title": "Sullivan, J. Courtney"
       },
       {
          "ISBN": 9781101871393,
          "Author": "My Italian bulldozer",
          "Title": "McCall Smith, Alexander, 1948-"
       },
       {
          "ISBN": 9781616205041,
          "Author": "Young Jane Young",
          "Title": "Zevin, Gabrielle"
       },
       {
          "ISBN": 9780385689380,
          "Author": "Rich people problems",
          "Title": "Kwan, Kevin"
       },
       {
          "ISBN": 9780765374653,
          "Author": "A dog's way home",
          "Title": "Cameron, W. Bruce"
       },
       {
          "ISBN": 9780374203108,
          "Author": "Sourdough",
          "Title": "Sloan, Robin, 1979-"
       },
       {
          "ISBN": 9780778330165,
          "Author": "Ginny Moon",
          "Title": "Ludwig, Benjamin, 1974-"
       },
       {
          "ISBN": 9780735217102,
          "Author": "The light we lost",
          "Title": "Santopolo, Jill"
       },
       {
          "ISBN": 9780735223493,
          "Author": "How to find love in a bookshop",
          "Title": "Henry, Veronica"
       },
       {
          "ISBN": 9780778330684,
          "Author": "Confessions of a Domestic Failure",
          "Title": "Laditan, Bunmi"
       },
       {
          "ISBN": 9780062663726,
          "Author": "The library at the edge of the world",
          "Title": "Hayes-McCoy, Felicity"
       },
       {
          "ISBN": 9781501139239,
          "Author": "The seven husbands of Evelyn Hugo",
          "Title": "Reid, Taylor Jenkins"
       },
       {
          "ISBN": 9780316013598,
          "Author": "The arrangement",
          "Title": "Dunn, Sarah, 1969-"
       },
       {
          "ISBN": 9780812993226,
          "Author": "The locals",
          "Title": "Dee, Jonathan, 1962-"
       },
       {
          "ISBN": 9780778319993,
          "Author": "Rise and shine, Benedict Stone",
          "Title": "Patrick, Phaedra"
       },
       {
          "ISBN": 9780778328735,
          "Author": "Hanna who fell from the sky",
          "Title": "Meades, Christopher"
       },
       {
          "ISBN": 9780399158926,
          "Author": "The confusion of languages",
          "Title": "Fallon, Siobhan"
       }
    ],
    "Literary fiction": [
       {
          "ISBN": 9780735224292,
          "Author": "Little fires everywhere",
          "Title": "Ng, Celeste"
       },
       {
          "ISBN": 9781476716732,
          "Author": "Manhattan Beach",
          "Title": "Egan, Jennifer"
       },
       {
          "ISBN": 9780812989403,
          "Author": "Anything is possible: fiction",
          "Title": "Strout, Elizabeth"
       },
       {
          "ISBN": 9780812995343,
          "Author": "Lincoln in the bardo",
          "Title": "Saunders, George, 1958-"
       },
       {
          "ISBN": 9781501137471,
          "Author": "The rules of magic",
          "Title": "Hoffman, Alice"
       },
       {
          "ISBN": 9781501126062,
          "Author": "Sing, unburied, sing",
          "Title": "Ward, Jesmyn"
       },
       {
          "ISBN": 9781524733155,
          "Author": "The ministry of utmost happiness",
          "Title": "Roy, Arundhati"
       },
       {
          "ISBN": 9780385350907,
          "Author": "The stars are fire",
          "Title": "Shreve, Anita"
       },
       {
          "ISBN": 9781501178139,
          "Author": "In the midst of winter",
          "Title": "Allende, Isabel"
       },
       {
          "ISBN": 9780735212176,
          "Author": "Exit west",
          "Title": "Hamid, Mohsin, 1971-"
       },
       {
          "ISBN": 9780062694058,
          "Author": "Future home of the living god",
          "Title": "Erdrich, Louise"
       },
       {
          "ISBN": 9781555977887,
          "Author": "Her body and other parties: stories",
          "Title": "Machado, Carmen Maria"
       },
       {
          "ISBN": 9780374280147,
          "Author": "The ninth hour",
          "Title": "McDermott, Alice"
       },
       {
          "ISBN": 9780802125392,
          "Author": "Difficult women",
          "Title": "Gay, Roxane"
       },
       {
          "ISBN": 9780316316125,
          "Author": "Less",
          "Title": "Greer, Andrew Sean"
       },
       {
          "ISBN": 9781101870730,
          "Author": "Autumn",
          "Title": "Smith, Ali, 1962-"
       },
       {
          "ISBN": 9780399592805,
          "Author": "The golden house",
          "Title": "Rushdie, Salman"
       },
       {
          "ISBN": 9780802125873,
          "Author": "History of wolves",
          "Title": "Fridlund, Emily"
       },
       {
          "ISBN": 9780451494627,
          "Author": "Men without women: stories",
          "Title": "Murakami, Haruki, 1949-"
       },
       {
          "ISBN": 9780802126399,
          "Author": "The refugees",
          "Title": "Nguyen, Viet Thanh, 1971-"
       },
       {
          "ISBN": 9780393635027,
          "Author": "The burning girl",
          "Title": "Messud, Claire, 1966-"
       },
       {
          "ISBN": 9781616206888,
          "Author": "The leavers",
          "Title": "Ko, Lisa"
       },
       {
          "ISBN": 9781627794466,
          "Author": "4 3 2 1",
          "Title": "Auster, Paul, 1947-"
       },
       {
          "ISBN": 9780812994049,
          "Author": "Idaho",
          "Title": "Ruskovich, Emily"
       }
    ],
    "Books to movies": [
       {
          "ISBN": 9780525562894,
          "Author": "Ames, Jonathan",
          "Title": "You were never really here"
       },
       {
          "ISBN": 9780525433385,
          "Author": "Vallejo, Virginia",
          "Title": "Loving Pablo, hating Escobar"
       },
       {
          "ISBN": 9781501137471,
          "Author": "Hoffman, Alice",
          "Title": "The rules of magic"
       },
       {
          "ISBN": 9780765377043,
          "Author": "Card, Orson Scott",
          "Title": "Children of the fleet"
       },
       {
          "ISBN": 9781510727748,
          "Author": "Ponicsan, Darryl",
          "Title": "Last flag flying"
       },
       {
          "ISBN": 9781785863400,
          "Author": "Nury, Fabien",
          "Title": "The death of Stalin"
       },
       {
          "ISBN": 9781590519158,
          "Author": "Djian, Philippe, 1949-",
          "Title": "Elle"
       },
       {
          "ISBN": 9781476799711,
          "Author": "Marion, Isaac, 1981-",
          "Title": "The burning world"
       },
       {
          "ISBN": 9781524732400,
          "Author": "Fielding, Helen, 1958-",
          "Title": "Bridget Jones's baby: the diaries"
       },
       {
          "ISBN": 9780062363596,
          "Author": "Lee Shetterly, Margot",
          "Title": "Hidden figures: the American dream and the untold story of the Black women mathematicians who helped win the space race"
       },
       {
          "ISBN": 9781610397339,
          "Author": "Sadler, Anthony",
          "Title": "The 15:17 to Paris: the true story of a terrorist, a train, and three American heroes"
       },
       {
          "ISBN": 9781606999325,
          "Author": "Roca, Paco, (Comic book artist)",
          "Title": "Wrinkles"
       },
       {
          "ISBN": 9780316294126,
          "Author": "Stillman, Whit, 1952-",
          "Title": "Love & friendship: in which Jane Austen's Lady Susan Vernon is entirely vindicated"
       },
       {
          "ISBN": 9781594633010,
          "Author": "Conley, Garrard",
          "Title": "Boy erased"
       },
       {
          "ISBN": 9781622869886,
          "Author": "Weber, Carl, 1964-",
          "Title": "No more Mr. Nice Guy: a family business novel"
       },
       {
          "ISBN": 9781469627052,
          "Author": "Bynum, Victoria E.",
          "Title": "The free state of Jones: Mississippi's longest civil war"
       },
       {
          "ISBN": 9780385354288,
          "Author": "Lagercrantz, David",
          "Title": "The girl in the spider's web: a Lisbeth Salander novel"
       },
       {
          "ISBN": 9781594634024,
          "Author": "Hawkins, Paula",
          "Title": "The girl on the train"
       },
       {
          "ISBN": 9780356502731,
          "Author": "Carey, M. R., 1959-",
          "Title": "The girl with all the gifts"
       },
       {
          "ISBN": 9780374104092,
          "Author": "Vandermeer, Jeff",
          "Title": "Annihilation"
       },
       {
          "ISBN": 9780804139021,
          "Author": "Weir, Andy",
          "Title": "The Martian"
       },
       {
          "ISBN": 9781568586717,
          "Author": "Scahill, Jeremy",
          "Title": "Dirty wars: the world is a battlefield"
       },
       {
          "ISBN": 9780307700667,
          "Author": "Wright, Lawrence, 1947-",
          "Title": "Going clear: Scientology, Hollywood, and the prison of belief"
       },
       {
          "ISBN": 9780670026227,
          "Author": "Mendez, Antonio J.",
          "Title": "Argo: how the CIA and Hollywood pulled off the most audacious rescue in history"
       }
    ]
 }



export let appeals = {
   "Creepy": [
      {
         "ISBN": 9781476783758,
         "Author": "Ahlborn, Ania",
         "Title": "The devil crept in"
      },
      {
         "ISBN": 9781250092175,
         "Author": "Armstrong, Kelley",
         "Title": "A darkness absolute"
      },
      {
         "ISBN": 9781101905609,
         "Author": "Barry, Brunonia",
         "Title": "The fifth petal"
      },
      {
         "ISBN": 9781501125072,
         "Author": "Boone, Ezekiel",
         "Title": "Skitter"
      },
      {
         "ISBN": 9780345531506,
         "Author": "Brett, Peter V.",
         "Title": "The Core"
      },
      {
         "ISBN": 9781627797054,
         "Author": "Brown, Karen, 1960-",
         "Title": "The clairvoyants"
      },
      {
         "ISBN": 9780345476043,
         "Author": "Chaon, Dan",
         "Title": "Ill will"
      },
      {
         "ISBN": 9780374282103,
         "Author": "Darnielle, John",
         "Title": "Universal harvester"
      },
      {
         "ISBN": 9780765390905,
         "Author": "Emrys, Ruthanna",
         "Title": "Winter tide"
      },
      {
         "ISBN": 9781510717268,
         "Author": "Forry, Lauren A.",
         "Title": "Abigale Hall"
      },
      {
         "ISBN": 9781250117052,
         "Author": "Golden, Christopher",
         "Title": "Ararat"
      },
      {
         "ISBN": 9780062562623,
         "Author": "Goodman, Carol",
         "Title": "The widow's house"
      },
      {
         "ISBN": 9780062663115,
         "Author": "Hill, Joe",
         "Title": "Strange weather: four short novels"
      },
      {
         "ISBN": 9780544746527,
         "Author": "Hurley, Andrew Michael, 1975-",
         "Title": "The Loney"
      },
      {
         "ISBN": 9780374536916,
         "Author": "Jemc, Jac, 1983-",
         "Title": "The grip of it"
      },
      {
         "ISBN": 9781501163401,
         "Author": "King, Stephen, 1947-",
         "Title": "Sleeping beauties"
      },
      {
         "ISBN": 9780062259684,
         "Author": "Malerman, Josh",
         "Title": "Black mad wheel"
      },
      {
         "ISBN": 9780544750333,
         "Author": "Percy, Benjamin",
         "Title": "The dark net"
      },
      {
         "ISBN": 9781476755212,
         "Author": "Pyper, Andrew",
         "Title": "The only child"
      },
      {
         "ISBN": 9781501102240,
         "Author": "Santiago, Mikel",
         "Title": "The last night at Tremore Beach"
      },
      {
         "ISBN": 9780802126597,
         "Author": "Schmidt, Sarah",
         "Title": "See what I have done"
      },
      {
         "ISBN": 9781478947387,
         "Author": "Tremayne, S. K., 1963-",
         "Title": "The fire child"
      },
      {
         "ISBN": 9781492637424,
         "Author": "Ward, Catriona",
         "Title": "The girl from Rawblood"
      },
      {
         "ISBN": 9780143111856,
         "Author": "Wasserberg, Eleanor",
         "Title": "Foxlowe"
      },
      {
         "ISBN": 9781250107404,
         "Author": "Yrsa Sigurdardottir",
         "Title": "The undesired"
      }
   ],
   "Fast-paced": [
      {
         "ISBN": 9781455586608,
         "Author": "Baldacci, David",
         "Title": "End game"
      },
      {
         "ISBN": 9780399176616,
         "Author": "Box, C. J.",
         "Title": "Vicious circle"
      },
      {
         "ISBN": 9780385514231,
         "Author": "Brown, Dan, 1964-",
         "Title": "Origin"
      },
      {
         "ISBN": 9780399593482,
         "Author": "Child, Lee",
         "Title": "The midnight line"
      },
      {
         "ISBN": 9781501171642,
         "Author": "Clark, Mary Higgins",
         "Title": "Every breath you take"
      },
      {
         "ISBN": 9780525955115,
         "Author": "Coben, Harlan, 1962-",
         "Title": "Don't let go"
      },
      {
         "ISBN": 9780316225908,
         "Author": "Connelly, Michael, 1956-",
         "Title": "Two kinds of truth"
      },
      {
         "ISBN": 9781501150326,
         "Author": "Coulter, Catherine",
         "Title": "The devil's triangle"
      },
      {
         "ISBN": 9780062473356,
         "Author": "Crichton, Michael, 1942-2008",
         "Title": "Dragon teeth"
      },
      {
         "ISBN": 9781455536375,
         "Author": "Deaver, Jeffery",
         "Title": "The burial hour"
      },
      {
         "ISBN": 9780525954583,
         "Author": "Gardner, Lisa",
         "Title": "Right behind you"
      },
      {
         "ISBN": 9780525954460,
         "Author": "Garwood, Julie",
         "Title": "Wired"
      },
      {
         "ISBN": 9780399163852,
         "Author": "Grafton, Sue",
         "Title": "Y is for yesterday"
      },
      {
         "ISBN": 9780385541176,
         "Author": "Grisham, John",
         "Title": "The rooster bar"
      },
      {
         "ISBN": 9781250075840,
         "Author": "Johansen, Iris",
         "Title": "No easy target"
      },
      {
         "ISBN": 9780345541437,
         "Author": "Kellerman, Jonathan",
         "Title": "Heartbreak Hotel"
      },
      {
         "ISBN": 9780345545992,
         "Author": "Koontz, Dean R. (Dean Ray), 1945-",
         "Title": "The silent corner"
      },
      {
         "ISBN": 9780451494320,
         "Author": "Lagercrantz, David",
         "Title": "The girl who takes an eye for an eye"
      },
      {
         "ISBN": 9780316274036,
         "Author": "Patterson, James, 1947-",
         "Title": "16th seduction"
      },
      {
         "ISBN": 9781250123114,
         "Author": "Robb, J. D., 1950-",
         "Title": "Echoes in death"
      },
      {
         "ISBN": 9780399184574,
         "Author": "Sandford, John, 1944 February 23-",
         "Title": "Golden prey"
      },
      {
         "ISBN": 9781250099563,
         "Author": "Scottoline, Lisa",
         "Title": "One perfect lie"
      },
      {
         "ISBN": 9780062354341,
         "Author": "Silva, Daniel, 1960-",
         "Title": "House of spies"
      },
      {
         "ISBN": 9780553448122,
         "Author": "Weir, Andy",
         "Title": "Artemis"
      },
      {
         "ISBN": 9780399573972,
         "Author": "Woods, Stuart",
         "Title": "Below the belt"
      }
   ],
   "Heartwarming": [
      {
         "ISBN": 9780764206245,
         "Author": "Alexander, Tamera",
         "Title": "A note yet unsung"
      },
      {
         "ISBN": 9781400069903,
         "Author": "Berg, Elizabeth",
         "Title": "The story of Arthur Truluv"
      },
      {
         "ISBN": 9781624167447,
         "Author": "Brunstetter, Wanda E.",
         "Title": "The seekers"
      },
      {
         "ISBN": 9781496708328,
         "Author": "Bunn, T. Davis, 1952-",
         "Title": "Firefly Cove"
      },
      {
         "ISBN": 9780765374653,
         "Author": "Cameron, W. Bruce",
         "Title": "A dog's way home"
      },
      {
         "ISBN": 9780778331049,
         "Author": "Carr, Robyn",
         "Title": "The summer that made us"
      },
      {
         "ISBN": 9780062569400,
         "Author": "Chambers, Becky",
         "Title": "A closed and common orbit "
      },
      {
         "ISBN": 9780316316996,
         "Author": "Emmich, Val",
         "Title": "The reminders"
      },
      {
         "ISBN": 9781501111648,
         "Author": "Evans, Richard Paul",
         "Title": "The broken road"
      },
      {
         "ISBN": 9780800727680,
         "Author": "Hannon, Irene",
         "Title": "Sandpiper cove: a Hope Harbor novel"
      },
      {
         "ISBN": 9780718085940,
         "Author": "Hatcher, Robin Lee",
         "Title": "You'll think of me"
      },
      {
         "ISBN": 9780764218040,
         "Author": "Hedlund, Jody",
         "Title": "With you always"
      },
      {
         "ISBN": 9780735223493,
         "Author": "Henry, Veronica",
         "Title": "How to find love in a bookshop"
      },
      {
         "ISBN": 9781101885024,
         "Author": "Jio, Sarah",
         "Title": "Always"
      },
      {
         "ISBN": 9780399183737,
         "Author": "Karon, Jan, 1937-",
         "Title": "To be where you are"
      },
      {
         "ISBN": 9781250105530,
         "Author": "Lamprell, Mark",
         "Title": "One summer day in Rome"
      },
      {
         "ISBN": 9781517902698,
         "Author": "Landvik, Lorna, 1954-",
         "Title": "Once in a Blue Moon Lodge"
      },
      {
         "ISBN": 9780764219092,
         "Author": "Lewis, Beverly, 1949-",
         "Title": "The ebb tide"
      },
      {
         "ISBN": 9781496422354,
         "Author": "Liggett, Cathy",
         "Title": "The sisters of Sugarcreek"
      },
      {
         "ISBN": 9780778330165,
         "Author": "Ludwig, Benjamin, 1974-",
         "Title": "Ginny Moon"
      },
      {
         "ISBN": 9780399584718,
         "Author": "McKinlay, Jenn",
         "Title": "About a dog"
      },
      {
         "ISBN": 9781501125461,
         "Author": "Monroe, Mary Alice",
         "Title": "Beach house for rent"
      },
      {
         "ISBN": 9780802127082,
         "Author": "Smith, Laura Lee, 1968-",
         "Title": "The ice house"
      },
      {
         "ISBN": 9781501165351,
         "Author": "Stewart, Mariah",
         "Title": "The Last Chance Matinee"
      },
      {
         "ISBN": 9780385541848,
         "Author": "Tunnicliffe, Hannah, 1979-",
         "Title": "A French wedding"
      }
   ],
   "Journalistic": [
      {
         "ISBN": 9780385537155,
         "Author": "Bair, Deirdre",
         "Title": "Al Capone: his life, legacy, and legend"
      },
      {
         "ISBN": 9780062372130,
         "Author": "Barry, Dan, 1958-",
         "Title": "The boys in the bunkhouse: servitude and salvation in the heartland"
      },
      {
         "ISBN": 9781476759692,
         "Author": "Berger, Jonah",
         "Title": "Invisible influence: the hidden forces that shape behavior"
      },
      {
         "ISBN": 9781591848141,
         "Author": "Bilton, Nick",
         "Title": "American kingpin: the epic hunt for the criminal mastermind behind the Silk Road"
      },
      {
         "ISBN": 9780385538435,
         "Author": "Blum, Ben, 1981-",
         "Title": "Ranger games: a story of soldiers, family, and an inexplicable crime"
      },
      {
         "ISBN": 9780393249316,
         "Author": "Bruder, Jessica",
         "Title": "Nomadland: surviving America in the twenty-first century"
      },
      {
         "ISBN": 9781416540274,
         "Author": "Burdick, Alan",
         "Title": "Why time flies: a mostly scientific investigation"
      },
      {
         "ISBN": 9781501126390,
         "Author": "Dunbar, Erica Armstrong",
         "Title": "Never caught: the Washingtons' relentless pursuit of their runaway slave, Ona Judge"
      },
      {
         "ISBN": 9781101904060,
         "Author": "Fountain, Henry",
         "Title": "The great quake: how the biggest earthquake in North America changed our understanding of the planet"
      },
      {
         "ISBN": 9781594206726,
         "Author": "Guthrie, Julian",
         "Title": "How to make a spaceship: a band of renegades, an epic race, and the birth of private spaceflight"
      },
      {
         "ISBN": 9781101874370,
         "Author": "Hagan, Joe, 1971-",
         "Title": "Sticky fingers: the life and times of Jann Wenner and Rolling stone magazine"
      },
      {
         "ISBN": 9781476777405,
         "Author": "Hammer, Joshua, 1957-",
         "Title": "The bad-ass librarians of Timbuktu: and their race to save the world's most precious manuscripts"
      },
      {
         "ISBN": 9781631490514,
         "Author": "Hesse, Monica",
         "Title": "American fire: love, arson, and life in a vanishing land"
      },
      {
         "ISBN": 9781631492556,
         "Author": "Kingsley, Patrick",
         "Title": "The new odyssey: the story of the twenty-first-century refugee crisis"
      },
      {
         "ISBN": 9780393254594,
         "Author": "Lewis, Michael (Michael M.)",
         "Title": "The undoing project: a friendship that changed our minds"
      },
      {
         "ISBN": 9781101906187,
         "Author": "Markham, Lauren",
         "Title": "The far away brothers: two young migrants and the making of an American life"
      },
      {
         "ISBN": 9781627798976,
         "Author": "Mekhennet, Souad",
         "Title": "I was told to come alone: my journey behind the lines of jihad"
      },
      {
         "ISBN": 9781101903858,
         "Author": "Mitchell, Greg, 1947-",
         "Title": "The tunnels: escapes under the Berlin Wall and the historic films the JFK White House tried to kill"
      },
      {
         "ISBN": 9780316439893,
         "Author": "Mundy, Liza, 1960-",
         "Title": "Code girls: the untold story of the American women code breakers who helped win World War II"
      },
      {
         "ISBN": 9780062378828,
         "Author": "Nordland, Rod",
         "Title": "The lovers: Afghanistan's Romeo and Juliet, the true story of how they defied their families and escaped an honor killing"
      },
      {
         "ISBN": 9781620971444,
         "Author": "Otto, Mary",
         "Title": "Teeth: the story of beauty, inequality, and the struggle for oral health in America"
      },
      {
         "ISBN": 9780385351751,
         "Author": "Prud'homme, Alex",
         "Title": "The French chef in America: Julia Child's second act"
      },
      {
         "ISBN": 9781250067630,
         "Author": "Rawlence, Ben",
         "Title": "City of thorns: nine lives in the world's largest refugee camp"
      },
      {
         "ISBN": 9780062440136,
         "Author": "Reynolds, Nicholas",
         "Title": "Writer, sailor, soldier, spy: Ernest Hemingway's secret adventures, 1935-1961"
      },
      {
         "ISBN": 9780525427643,
         "Author": "Shapiro, Laura",
         "Title": "What she ate: six remarkable women and the food that tells their stories"
      }
   ],
   "Lyrical": [
      {
         "ISBN": 9780544912588,
         "Author": "Alyan, Hala, 1986-",
         "Title": "Salt houses"
      },
      {
         "ISBN": 9780451493422,
         "Author": "Banville, John",
         "Title": "Mrs. Osmond"
      },
      {
         "ISBN": 9780525427360,
         "Author": "Barry, Sebastian, 1955-",
         "Title": "Days without end"
      },
      {
         "ISBN": 9780385538916,
         "Author": "Bohjalian, Chris, 1960-",
         "Title": "The sleepwalker"
      },
      {
         "ISBN": 9781627797641,
         "Author": "Buntin, Julie",
         "Title": "Marlena"
      },
      {
         "ISBN": 9780062678102,
         "Author": "Chakraborty, S. A.",
         "Title": "The city of brass"
      },
      {
         "ISBN": 9780062661098,
         "Author": "Chancellor, Bryn",
         "Title": "Sycamore"
      },
      {
         "ISBN": 9780062694058,
         "Author": "Erdrich, Louise",
         "Title": "Future home of the living god"
      },
      {
         "ISBN": 9780393609097,
         "Author": "Gaiman, Neil",
         "Title": "Norse mythology"
      },
      {
         "ISBN": 9780316316125,
         "Author": "Greer, Andrew Sean",
         "Title": "Less"
      },
      {
         "ISBN": 9781101906729,
         "Author": "Han, Kang, 1970-",
         "Title": "Human acts"
      },
      {
         "ISBN": 9780399574634,
         "Author": "Howrey, Meg",
         "Title": "The wanderers"
      },
      {
         "ISBN": 9780316229241,
         "Author": "Jemisin, N. K.",
         "Title": "The stone sky"
      },
      {
         "ISBN": 9780316243964,
         "Author": "Kent, Hannah, 1985-",
         "Title": "The good people"
      },
      {
         "ISBN": 9780345527868,
         "Author": "Kostova, Elizabeth",
         "Title": "The shadow land"
      },
      {
         "ISBN": 9780316363297,
         "Author": "Locke, Attica",
         "Title": "Bluebird, bluebird"
      },
      {
         "ISBN": 9781784782771,
         "Author": "Mieville, China",
         "Title": "October: the story of the Russian Revolution"
      },
      {
         "ISBN": 9780674976450,
         "Author": "Morrison, Toni",
         "Title": "The origin of others"
      },
      {
         "ISBN": 9781250066190,
         "Author": "Penny, Louise",
         "Title": "Glass houses"
      },
      {
         "ISBN": 9780062666376,
         "Author": "Perry, Sarah, 1979-",
         "Title": "The Essex serpent"
      },
      {
         "ISBN": 9781501169359,
         "Author": "Riggs, Nina",
         "Title": "The bright hour: a memoir of living and dying"
      },
      {
         "ISBN": 9781524733155,
         "Author": "Roy, Arundhati",
         "Title": "The ministry of utmost happiness"
      },
      {
         "ISBN": 9780374115241,
         "Author": "VanderMeer, Jeff",
         "Title": "Borne"
      },
      {
         "ISBN": 9781524731748,
         "Author": "Wang, Weike",
         "Title": "Chemistry"
      },
      {
         "ISBN": 9780062383273,
         "Author": "Yuknavitch, Lidia",
         "Title": "The book of Joan"
      }
   ],
   "Moving": [
      {
         "ISBN": 9781501178139,
         "Author": "Allende, Isabel",
         "Title": "In the midst of winter"
      },
      {
         "ISBN": 9781627794466,
         "Author": "Auster, Paul, 1947-",
         "Title": "4 3 2 1"
      },
      {
         "ISBN": 9781501160769,
         "Author": "Backman, Fredrik, 1981-",
         "Title": "Beartown"
      },
      {
         "ISBN": 9780062313119,
         "Author": "Cash, Wiley",
         "Title": "The last ballad"
      },
      {
         "ISBN": 9781476716732,
         "Author": "Egan, Jennifer",
         "Title": "Manhattan Beach"
      },
      {
         "ISBN": 9781606999592,
         "Author": "Ferris, Emil",
         "Title": "My favorite thing is monsters. Book one"
      },
      {
         "ISBN": 9780804176750,
         "Author": "Ford, Jamie",
         "Title": "Love and other consolation prizes"
      },
      {
         "ISBN": 9780802125873,
         "Author": "Fridlund, Emily",
         "Title": "History of wolves"
      },
      {
         "ISBN": 9780316375191,
         "Author": "Hilderbrand, Elin",
         "Title": "The identicals"
      },
      {
         "ISBN": 9780735220683,
         "Author": "Honeyman, Gail",
         "Title": "Eleanor Oliphant is completely fine"
      },
      {
         "ISBN": 9780399563089,
         "Author": "Hunter, Georgia, 1978-",
         "Title": "We were the lucky ones"
      },
      {
         "ISBN": 9780062105714,
         "Author": "Jackson, Joshilyn",
         "Title": "The almost sisters"
      },
      {
         "ISBN": 9780778330639,
         "Author": "Jenoff, Pam",
         "Title": "The orphan's tale"
      },
      {
         "ISBN": 9781616206888,
         "Author": "Ko, Lisa",
         "Title": "The leavers"
      },
      {
         "ISBN": 9781455563937,
         "Author": "Lee, Min Jin",
         "Title": "Pachinko"
      },
      {
         "ISBN": 9780374280147,
         "Author": "McDermott, Alice",
         "Title": "The ninth hour"
      },
      {
         "ISBN": 9780812994049,
         "Author": "Ruskovich, Emily",
         "Title": "Idaho"
      },
      {
         "ISBN": 9780812995343,
         "Author": "Saunders, George, 1958-",
         "Title": "Lincoln in the bardo"
      },
      {
         "ISBN": 9781501154829,
         "Author": "See, Lisa",
         "Title": "The tea girl of Hummingbird Lane"
      },
      {
         "ISBN": 9780062675644,
         "Author": "Shalvis, Jill",
         "Title": "Lost and found sisters"
      },
      {
         "ISBN": 9780062430243,
         "Author": "Slaughter, Karin, 1971-",
         "Title": "The good daughter"
      },
      {
         "ISBN": 9781101883914,
         "Author": "Steel, Danielle",
         "Title": "Against all odds"
      },
      {
         "ISBN": 9780307959577,
         "Author": "Sullivan, J. Courtney",
         "Title": "Saints for all occasions"
      },
      {
         "ISBN": 9780062319227,
         "Author": "Trigiani, Adriana",
         "Title": "Kiss Carlo"
      },
      {
         "ISBN": 9780062472984,
         "Author": "Watts, Stephanie Powell",
         "Title": "No one is coming to save us"
      }
   ],
   "Strong sense of place": [
      {
         "ISBN": 9781250066923,
         "Author": "Archer, Jeffrey, 1940-",
         "Title": "Tell tale: short stories"
      },
      {
         "ISBN": 9780425283509,
         "Author": "Bowen, Rhys",
         "Title": "On her majesty's frightfully secret service"
      },
      {
         "ISBN": 9780553392494,
         "Author": "Brown, Rita Mae",
         "Title": "A hiss before dying: A Mrs. Murphy Mystery"
      },
      {
         "ISBN": 9780425281680,
         "Author": "Childs, Laura",
         "Title": "Pekoe most poison"
      },
      {
         "ISBN": 9780062271631,
         "Author": "Crombie, Deborah",
         "Title": "Garden of lamentations"
      },
      {
         "ISBN": 9780735213005,
         "Author": "Dionne, Karen",
         "Title": "The Marsh King's daughter"
      },
      {
         "ISBN": 9780765374875,
         "Author": "Graham, Heather",
         "Title": "American drifter"
      },
      {
         "ISBN": 9780451488534,
         "Author": "Hart, Carolyn G.",
         "Title": "Walking on my grave"
      },
      {
         "ISBN": 9780451493897,
         "Author": "Heller, Peter, 1959-",
         "Title": "Celine"
      },
      {
         "ISBN": 9780062391902,
         "Author": "Hillerman, Anne, 1949-",
         "Title": "Song of the lion"
      },
      {
         "ISBN": 9781501121395,
         "Author": "Kanon, Joseph",
         "Title": "Defectors"
      },
      {
         "ISBN": 9780062430991,
         "Author": "Krauss, Nicole",
         "Title": "Forest Dark"
      },
      {
         "ISBN": 9780802126474,
         "Author": "Leon, Donna",
         "Title": "Earthly remains"
      },
      {
         "ISBN": 9781101871379,
         "Author": "McCall Smith, Alexander, 1948-",
         "Title": "The house of unexpected sisters"
      },
      {
         "ISBN": 9780316380577,
         "Author": "Mina, Denise",
         "Title": "The long drop"
      },
      {
         "ISBN": 9781455538928,
         "Author": "Muller, Marcia",
         "Title": "The color of fear"
      },
      {
         "ISBN": 9780425284988,
         "Author": "Perry, Anne",
         "Title": "Murder on the Serpentine: a Charlotte and Thomas Pitt novel"
      },
      {
         "ISBN": 9780316342575,
         "Author": "Rankin, Ian",
         "Title": "Rather be the devil"
      },
      {
         "ISBN": 9781616205812,
         "Author": "Rivers, Susan, 1954-",
         "Title": "The second Mrs. Hockaday"
      },
      {
         "ISBN": 9781501163876,
         "Author": "Spufford, Francis, 1964-",
         "Title": "Golden hill"
      },
      {
         "ISBN": 9781501116841,
         "Author": "Sullivan, Matthew, 1970-",
         "Title": "Midnight at the Bright Ideas bookstore"
      },
      {
         "ISBN": 9780735211179,
         "Author": "Tallent, Gabriel",
         "Title": "My absolute darling"
      },
      {
         "ISBN": 9781101967072,
         "Author": "Thayer, Nancy, 1943-",
         "Title": "Secrets in summer"
      },
      {
         "ISBN": 9781501126062,
         "Author": "Ward, Jesmyn",
         "Title": "Sing, unburied, sing"
      },
      {
         "ISBN": 9780399576683,
         "Author": "White, Randy Wayne",
         "Title": "Mangrove lightning"
      }
   ]
}


// WEBPACK FOOTER //
// ./src/config/Discover.ts